import type { ComplianceOverviewItem, ComplianceOverviewListQuery, Page } from '@chukua/common';
import { Table, type TableColumnsType } from 'antd';
import { ShieldCheck, SearchX } from 'lucide-react';
import { EmptyState } from '../../../shared/components/EmptyState';
import { ListSearch } from '../../../shared/components/ListSearch';
import type { ListQueryControls } from '../../../shared/hooks/use-list-query';

interface ComplianceOverviewTableProps {
  page: Page<ComplianceOverviewItem>;
  columns: TableColumnsType<ComplianceOverviewItem>;
  list: ListQueryControls<ComplianceOverviewListQuery>;
  isRefreshing: boolean;
}

/** Search box plus the server-paged table; the old rows stay up, dimmed, while the next page loads. */
export function ComplianceOverviewTable({ page, columns, list, isRefreshing }: ComplianceOverviewTableProps) {
  return (
    <div className="flex flex-col gap-4">
      <ListSearch value={list.query.q} placeholder="Search holder" onSearch={(q) => list.setQuery({ q }, { replace: true })} />
      <Table
        rowKey="id"
        dataSource={page.items}
        columns={columns}
        loading={isRefreshing}
        scroll={{ x: 'max-content' }}
        locale={list.isFiltered ? { emptyText: <NoMatchingExceptions /> } : { emptyText: <NothingOutstanding /> }}
        {...list.tableProps<ComplianceOverviewItem>(page.total)}
      />
    </div>
  );
}

function NoMatchingExceptions() {
  return <EmptyState icon={SearchX} title="No matching exceptions" description="No documents match this search or these filters." />;
}

function NothingOutstanding() {
  return <EmptyState icon={ShieldCheck} title="Nothing outstanding" description="No expired, expiring or missing documents across the fleet right now." />;
}
